'use strict';

var AppleRegSplashController = function ($sce, $scope, $location) {
     var shost = $location.host();
     var prodSearch = ['myapple401k', 'proda', 'prodb'];
     var prodUrl = false;
     var url = prodUrl ? "https://hrweb.apple.com/US/en/page/82" : "https://hrweb-uat.apple.com/US/en/page/82";

     prodSearch.forEach(function (search) {
          if (shost.indexOf(search) > -1)
               prodUrl = true;
     });

     $scope.AppleHrUrl = $sce.getTrustedUrl($sce.trustAsUrl(url));
};

AppleRegSplashController.$inject = ['$sce', '$scope', '$location'];
export default AppleRegSplashController;
